import axios from "axios";
import { API_URL } from "@/Constant";

/**
 * Mirrors the branch rows seeded in the backend. Used only if the API is
 * unreachable at build time, so the Contact Us page never renders empty.
 */
export const FALLBACK_BRANCHES = [
  {
    id: 1,
    name: "Karnal (Head Office)",
    address:
      "SCO 340, Mugal Canal Rd, Old Char Chaman, Dyal Singh Colony, Karnal, Haryana 132001",
    city: "Karnal",
    state: "Haryana",
    country: "India",
    postalCode: "132001",
    phone: "+91-9338000045",
    latitude: 29.6859,
    longitude: 76.9947,
    hasMap: null,
    isHQ: true,
    sortOrder: 1,
  },
  {
    id: 2,
    name: "Nawanshahr",
    address:
      "BL Tower, Banga Rd, opp. sugar Mill, Guru Teg Bahadar Nagar, Nawanshahr, Punjab 144514",
    city: "Nawanshahr",
    state: "Punjab",
    country: "India",
    phone: "+91-7797000045",
    isHQ: false,
    sortOrder: 2,
  },
  {
    id: 3,
    name: "Chandigarh",
    address: "SCO 447-448, First Floor, Sector 35 C, Chandigarh",
    city: "Chandigarh",
    state: "Chandigarh",
    country: "India",
    phone: "+91-9134000005",
    isHQ: false,
    sortOrder: 3,
  },
  {
    id: 4,
    name: "Indri",
    address: "Ward no 9, Bajaj Colony, Indri",
    city: "Indri",
    state: "Haryana",
    country: "India",
    phone: "+91-9338000045",
    isHQ: false,
    sortOrder: 4,
  },
  {
    id: 5,
    name: "Dubai",
    address: "",
    city: "Dubai",
    country: "UAE",
    phone: "+91-9338000045",
    isHQ: false,
    sortOrder: 5,
  },
  {
    id: 6,
    name: "Canada",
    address: "52 Ashford Ct, Brampton, ON L6V 2Z1, Canada",
    city: "Brampton",
    state: "ON",
    country: "Canada",
    postalCode: "L6V 2Z1",
    phone: "+1 (548) 384-4545",
    isHQ: false,
    sortOrder: 6,
  },
];

const REQUEST_TIMEOUT_MS = 5000;

/** Head office first, then the admin's sort order. */
const sortBranches = (branches) =>
  [...branches].sort((a, b) => {
    if (!!b.isHQ !== !!a.isHQ) return b.isHQ ? 1 : -1;
    return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
  });

export async function getBranches() {
  try {
    const { data } = await axios.get(`${API_URL}/branches`, {
      timeout: REQUEST_TIMEOUT_MS,
    });

    const branches = Array.isArray(data?.data) ? data.data : [];
    if (data?.success && branches.length > 0) {
      return sortBranches(branches);
    }
  } catch (err) {
    console.error("[contact] branches fetch failed:", err.message);
  }

  return sortBranches(FALLBACK_BRANCHES);
}
